// Hero slide content entrance reveal.
//
// As each hero slide becomes active, its content (eyebrow → heading → body → buttons) fades and
// rises in a short stagger — a premium "build-on" that gives the homepage movement without touching
// the layout. Pure CSS does the animation (see hero-slide-frame.liquid); this module only:
//   1. marks the slideshow `hero-reveal-ready` so the CSS initial-hidden state engages — and ONLY
//      when motion is allowed, so no-JS / reduced-motion users get fully-visible content (no flash),
//   2. toggles `is-revealing` on the active slide's inner on each `slideshow:select` (the same
//      bubbling event the autoplay timing uses), replaying the stagger on every (re)entry.
//
// Compositor-only (opacity/transform), no layout reads, no per-frame work — negligible INP cost.

(() => {
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)');

  const reveal = (slide) => {
    if (!slide) return;
    const inner = slide.querySelector('.hero-slide__inner');
    if (!inner) return;
    // Restart the transition on re-entry: drop the class, force a reflow, re-add.
    inner.classList.remove('is-revealing');
    void inner.offsetWidth;
    inner.classList.add('is-revealing');
  };

  const bind = (slideshow) => {
    if (slideshow.dataset.heroRevealBound) return;
    slideshow.dataset.heroRevealBound = '1';

    // Honor reduced motion: leave content static and visible (don't add the ready class).
    if (reduce.matches) return;

    const first =
      slideshow.querySelector('slideshow-slide[aria-hidden="false"]') ||
      slideshow.querySelector('slideshow-slide');
    first?.querySelector('.hero-slide__inner')?.classList.add('is-revealing');

    slideshow.classList.add('hero-reveal-ready');

    slideshow.addEventListener('slideshow:select', (event) => {
      reveal(event.detail && event.detail.slide);
    });
  };

  const init = () => {
    document.querySelectorAll('slideshow-component.hero-slider--reveal').forEach(bind);
  };

  if (document.readyState !== 'loading') {
    init();
  } else {
    document.addEventListener('DOMContentLoaded', init);
  }

  // Theme editor: a section re-render swaps in a fresh slideshow element (the bind flag is lost),
  // so re-bind any hero sliders inside the reloaded section.
  document.addEventListener('shopify:section:load', (event) => {
    const root = event.target;
    if (!root || typeof root.querySelectorAll !== 'function') return;
    root.querySelectorAll('slideshow-component.hero-slider--reveal').forEach(bind);
  });
})();
